import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    isMobile: 0// 是否是手机端
}

const mutations = {
    isMobile(state, val) {
        state.isMobile = val
    }
}

const actions = {
    isMobile({commit}, val) {
        commit('isMobile', val)
    }
}
export default new Vuex.Store({
    state,
    mutations,
    actions
})
